import { render, staticRenderFns } from "./FilterCategoryChip.vue?vue&type=template&id=3d92c802&scoped=true&"
import script from "./FilterCategoryChip.vue?vue&type=script&lang=ts&"
export * from "./FilterCategoryChip.vue?vue&type=script&lang=ts&"
import style0 from "./FilterCategoryChip.vue?vue&type=style&index=0&id=3d92c802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d92c802",
  null
  
)

export default component.exports